import { formatZonedDate } from 'legacy/utils/date/formatZonedDate'

function groupLoadOffersByDate(orderedLoadOffers) {
  if (!orderedLoadOffers || !Array.isArray(orderedLoadOffers)) return null

  const groupedByDate = []
  let sameDateLoadOffers = []
  let lastDate = null
  orderedLoadOffers.forEach((loadOffer, idx) => {
    const { window_start, timezone } = loadOffer.load.stops[0]
    const date = formatZonedDate(window_start, timezone, 'eeee, MMMM d')

    if (lastDate !== date) {
      lastDate = date
      sameDateLoadOffers = [] // once we change dates, we starting adding to a new array
      groupedByDate.push({
        date: date,
        loadOffers: sameDateLoadOffers,
      })
    }

    sameDateLoadOffers.push({
      ...loadOffer,
      position: idx, // For tracking position on page
    })
  })
  return groupedByDate
}

export { groupLoadOffersByDate }
